import { stripHTML } from "./string";

export async function copyTextToClipboard(text: string): Promise<void> {
  if (!text) {
    return Promise.reject();
  }

  try {
    return await navigator.clipboard.writeText(text);
  } catch {
    // The clipboard api is blocked in cross-origin iframes unless the iframe
    // has allow="clipboard-write"
    const success = fallbackCopyTextToClipboard(text);
    return success ? Promise.resolve() : Promise.reject();
  }
}

// Adapted from fraction
function fallbackCopyTextToClipboard(text: string) {
  if (fallbackCopyToClipboardEnabled() && text.length > 0) {
    const copyTextDiv = document.createElement("div");
    copyTextDiv.setAttribute("aria-hidden", "true");
    copyTextDiv.style.background = "transparent";
    copyTextDiv.innerHTML = text;
    document.body.appendChild(copyTextDiv);
    const range = document.createRange();
    range.selectNode(copyTextDiv);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
      document.execCommand("copy");
    }
    if (copyTextDiv.parentNode) {
      copyTextDiv.parentNode.removeChild(copyTextDiv);
    }
    return !!sel;
  } else {
    return false;
  }
}

// Adapted from fraction
function fallbackCopyToClipboardEnabled() {
  try {
    return (
      document.queryCommandEnabled("copy") ||
      document.queryCommandSupported("copy")
    );
  } catch (e) {
    return false;
  }
}

export async function copyRichTextToClipboard(html: string): Promise<void> {
  const plainText = stripHTML(html);

  try {
    const clipboardItem = new ClipboardItem({
      "text/html": new Blob([html], { type: "text/html" }),
      "text/plain": new Blob([plainText], { type: "text/plain" }),
    });
    return await navigator.clipboard.write([clipboardItem]);
  } catch (err) {
    return copyTextToClipboard(plainText);
  }
}
